'use client';

import { event_button_click, event_installment_option } from '@/utils/gtm';
import Image from 'next/image';
import Link from 'next/link';
import CurrencyIcon from '../ui/icons/currency-icon';

export default function EmkanWidget({ amount, locale, buttonLocation }) {
  const payment = (amount / 5).toFixed(2);
  const isRtl = locale === 'ar';

  const text =
    locale === 'ar'
      ? `قسم دفعاتك الى 5 دفعات بدون فوائد بقيمة ${payment} `
      : `Split in up to 5 interest-free payments of ${payment} `;

  const learnMoreText = locale === 'ar' ? 'اعرف اكثر' : 'Learn more';

  return (
    // Gradient border wrapper
    <div
      className='border-border flex min-h-[55px] items-center rounded-md border bg-white px-1'
      // style={{
      //   background:
      //     "linear-gradient(95.13deg, #767fff 0.28%, #2dd0c2 24.36%, #7382fd 42.87%, #24daba 59.18%, #4baedb 81.93%, #21ddb8 100%)",
      // }}
      dir={isRtl ? 'rtl' : 'ltr'}
    >
      <div className='w-[62px] shrink-0'>
        <Image
          width={90}
          height={90}
          src={`/imgs/payments/emkan-logo-${locale}.png`}
          alt='emkan'
          className='w-full object-contain'
        />
      </div>
      <div className='flex flex-col gap-2 rounded-xl bg-white p-3'>
        <p className='m-0 text-base font-medium text-black'>
          {text}
          <CurrencyIcon className='inline-block size-3' />
          <Link
            href='https://www.emkanfinance.com.sa/'
            target='_blank'
            rel='noopener noreferrer'
            className='text-[12px] whitespace-nowrap underline'
            onClick={() => {
              event_installment_option({ merchant_name: 'emkan' });
              event_button_click({
                button_name: 'Emkan',
                button_destination: 'https://www.emkanfinance.com.sa/',
                button_location: buttonLocation,
              });
            }}
          >
            {' '}
            {learnMoreText}
          </Link>
        </p>
      </div>
    </div>
  );
}
